import { Link } from "react-router-dom";

export default function NotFound() {
    return (
        <div className="page-fade min-h-[60vh] flex items-center justify-center px-6">
            <div className="text-center space-y-6 max-w-md">
                <div className="eyebrow">404 · Not Found</div>
                <h1 className="editorial-headline text-7xl">Misplaced.</h1>
                <p className="text-ink/60">The page you're looking for doesn't exist or has been moved.</p>
                <Link to="/" className="btn-primary inline-flex">Return Home</Link>
            </div>
        </div>
    );
}
